import { Get } from "../api/ApiBase";

export async function GetReportToken() {
  return await Get("/api/GetReportToken");
}
